import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface BalanceRow {
  wallet_id: string;
  owner_id: string;
  owner_type: 'user' | 'department' | 'location';
  owner_name: string;
  owner_department_id?: string;
  owner_department_name?: string;
  currency_type_id: string;
  currency_code: string;
  currency_name: string;
  balance: number;
  updated_at: number;
}

export interface CurrencyTotal {
  currency_type_id: string;
  currency_code: string;
  currency_name: string;
  total: number;
  by_owner_type: {
    user: number;
    department: number;
    location: number;
  };
}

export interface BalanceSummary {
  currencies: CurrencyTotal[];
  counts: {
    users: number;
    departments: number;
    locations: number;
    wallets: number;
  };
}

export interface BalanceFilters {
  owner_type?: 'user' | 'department' | 'location';
  currency_type_id?: string;
  department_id?: string;
  search?: string;
  only_with_balance?: boolean;
}

function buildQuery(filters: BalanceFilters = {}): string {
  const params = new URLSearchParams();
  if (filters.owner_type) params.append('owner_type', filters.owner_type);
  if (filters.currency_type_id) params.append('currency_type_id', filters.currency_type_id);
  if (filters.department_id) params.append('department_id', filters.department_id);
  if (filters.search) params.append('search', filters.search);
  if (filters.only_with_balance) params.append('only_with_balance', 'true');
  const q = params.toString();
  return q ? `?${q}` : '';
}

export const balanceService = {
  async listBalances(filters?: BalanceFilters): Promise<BalanceRow[]> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/balances${buildQuery(filters)}`
    );
    return response.data || [];
  },

  async getSummary(filters?: BalanceFilters): Promise<BalanceSummary> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/balances/summary${buildQuery(filters)}`
    );
    return response.data;
  },

  async getOwnerBalances(
    ownerType: 'user' | 'department' | 'location',
    ownerId: string
  ): Promise<BalanceRow[]> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/balances/owner/${ownerType}/${ownerId}`
    );
    return response.data || [];
  },
};